<template>
  <g>
    <path
      d="M5.205 8.500 A1.875 1.875 0 1 0 8.955 8.500 A1.875 1.875 0 1 0 5.205 8.500 Z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.2,16.955,15.828,10.4a.844.844,0,0,0-1.393-.015L12.19,13.6,10.8,12.483a.843.843,0,0,0-1.229.191l-2.865,4.3"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.25,3.023a1.5,1.5,0,0,0-1.5,1.5V19.477a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5v-12a1.5,1.5,0,0,0-.426-1.047L19.941,3.475a1.5,1.5,0,0,0-1.074-.452Z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconImage",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>